import Badge from '@components/UI/Badge';
import Button from '@components/UI/Button'

import useMods from '@hooks/useMods'

import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { useAtom } from 'jotai'

import Plan from './atoms/Plan'
import Pointer from './PricingTogglePointer'
import { twJoin } from 'tailwind-merge';

const PricingTogglePadding = 4

const PricingToggle = ({ mods={}, plans, onClick }) => {
    const { className } = useMods(PricingToggle, { mods })

    const cssPointer = mods['css-pointer'] || false

    const activePlanRef = useRef(null)

    const [plan, setPlan] = useAtom(Plan)
    const [pointerStyle, setPointerStyle] = useState({ translateX: 0 })

    const handleOptionClick = (event, value) => {
        setPlan(value)

        if (!cssPointer) {
            setPointerStyle({
                translateX: event.target.offsetLeft - PricingTogglePadding,
                translateY: event.target.offsetTop - PricingTogglePadding
            })
        }
    }

    useEffect(() => {
        if (!cssPointer) {
            new ResizeObserver(e => {
                const target = e[0].target.querySelector('button.active')

                setPointerStyle({
                    translateX: target.offsetLeft - PricingTogglePadding,
                    translateY: target.offsetTop - PricingTogglePadding
                })
            }).observe(document.querySelector('.pricing-toggle'))
        }

        setPlan(activePlanRef.current.innerHTML)
    }, [])

    return (
        <div className={ className }>

            { plans.map((item, index) => (
                <Button
                    key={ index }
                    onClick={ e => {
                        handleOptionClick(e, item.name)
                        onClick && onClick(item.name)
                    } }
                    ref={ item.selected ? activePlanRef : null }
                    className={ `!px-0 w-full ${ item.name === plan ? 'active' : '' }` }
                >
                    { item.name }
                    {parseFloat(item.discount) > 0 && (
                        <span 
                            className={twJoin(
                                "ml-[6px] relative bottom-2 font-caveat font-bold",
                                item.name === plan ? "text-violet-100" : "text-[#F1503A]"
                            )}
                        >
                            {`-${parseFloat(item.discount).toFixed(0)}%`}
                        </span>
                    )}
                </Button>
            )) }

            {!cssPointer && <Pointer
                style={ {
                    transform: `translate(${ pointerStyle.translateX }px, ${ pointerStyle.translateY }px)`
                } }
                className='w-[calc(100%-.5rem)] 768:w-192p'
            /> }
        </div>
    )
}

PricingToggle.displayName = 'Pricing-Toggle'

PricingToggle.propTypes = {
    mods: PropTypes.object,
    plans: PropTypes.array
}

export default PricingToggle
